import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FinalScene from '../scenes/FinalScene';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import FontKeys from '../FontKeys';
import ABCyaLib from '@abcya/abcya_lib';

export default class EndMenu extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {FinalScene} scene 
     */
    constructor(scene)
    {
        super(scene);
        this.delegate = scene;

        this.buttonStrip = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_assets_MenuStrip, this).setOrigin(0);

        const menuButtonTextYPosition = ABCyaLib.Environment.instance.gameConfig.menuButtonTextYPosition;

        this.btnStartOver = ABCyaPhaser.Images.addImage(this.scene.scale.width * 0.25, this.buttonStrip.y + this.buttonStrip.height / 2, UIAssetKeys._game_assets_BTN_1, this).setInteractive();
        this.btnStartOver.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            this.delegate.nextScene();
        }, this);
        const startOverTxt = ABCyaPhaser.Text.addText(this.btnStartOver.x, this.btnStartOver.y+menuButtonTextYPosition, 18, 0xffffff, FontKeys._bpreplayregular, ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.menu_popup.start_over_button"), this, true).setResolution(1.5).setLineSpacing(-5);

        this.btnSave =ABCyaPhaser.Images.addImage(this.scene.scale.width/2, this.buttonStrip.y + this.buttonStrip.height/2, UIAssetKeys._game_assets_BTN_2, this).setInteractive();
        this.btnSave.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, ()=>
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._button_click, this.scene);
            this.delegate.save();
        }, this);
        const saveTxt = ABCyaPhaser.Text.addText(this.btnSave.x, this.btnSave.y+menuButtonTextYPosition, 18, 0xffffff, FontKeys._bpreplayregular, ABCyaPhaser.Localization.instance.getLocalizedString("print_screen.save_button"), this, true).setResolution(1.5);

        this.btnPrint =ABCyaPhaser.Images.addImage(this.scene.scale.width*0.75, this.buttonStrip.y + this.buttonStrip.height/2, UIAssetKeys._game_assets_BTN_3, this).setInteractive();
        this.btnPrint.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, ()=>
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._button_click, this.scene);
            this.delegate.print();
        }, this);
        const printTxt = ABCyaPhaser.Text.addText(this.btnPrint.x, this.btnPrint.y+menuButtonTextYPosition, 18, 0xffffff, FontKeys._bpreplayregular, ABCyaPhaser.Localization.instance.getLocalizedString("print_screen.print_button"), this, true).setResolution(1.5);

        this.workingWidth = this.scene.scale.width;
        this.workingHeight = this.btnSave.y + (this.btnSave.height/2) - 40;
    }
}